import WestIcon from '@mui/icons-material/West';
import { IconButton, styled } from '@mui/material';

export const IconButtonW = styled(IconButton)`
  position: relative;
  left: -8px;
`;

export const ArrowIcon = styled(WestIcon)`
  color: ${({ theme }) => theme.palette.primary.p080};
  stroke: ${({ theme }) => theme.palette.white.main};
  stroke-width: 1.5;
  transform: scale(1.5);
`;
